import { Pipe, PipeTransform } from '@angular/core';
import {formatDate} from '@angular/common';

@Pipe({
  name: 'checkDate'
})
export class CheckDatePipe implements PipeTransform {

  transform(date: Date | string, year: number): string {
    const dateToCheck = new Date(date).getTime();
    const comparisonDate = new Date(year, 1, 1).getTime();
    if (!date || dateToCheck < comparisonDate) {
      return '--';
    }
    return formatDate(dateToCheck, 'dd/MM/yy', 'it');
  }

}
